module.exports = __webpack_public_path__ + "img/03-3-5方便创建.9ff12b25.svg";